
import { Component, Vue } from "vue-property-decorator";
import MenuEquipo from "@/components/Menus/MenuEquipo.vue";

@Component({
  components: {
    MenuEquipo,
  }
})
export default class EquipoPlayer extends Vue {
  // beforeDestroy() {
  //   console.log("BEFORE DESTROY EquipoPlayer");
  //   console.log("store.to: " + this.$store.state.toRoute + " store.from: " + this.$store.state.fromRoute);
  // }
}

